import {Observable} from 'rxjs';
import { retry as retryOp, delay as delayOp } from 'rxjs/operators';

export interface Response<T> {
  data: T;
  error: { [key: string]: string };
}

export const  isResponseType = <T>(value: unknown): value is Response<T> => {
  return (value as Response<T>).data !== undefined;
};

/**
 * An operator which will retry with a delay on the observable when an error happens.
 * @param retry number of retries to make when an error happens, by default 2
 * @param delay delay to be made between retries in milliseconds, by default 1000
 * @return An observable with retry and delay wrapped together
 */
export const retryWithDelay = <T>(retry: number = 2, delay: number = 1000) => {
  return (source: Observable<T>) => {
    return source.pipe(
      retryOp(retry),
      delayOp(delay)
    );
  };
};
